export const GET_MAP_LAYERS = "GET_MAP_LAYERS";
export const MAP_LAYERS_RECEIVED = "MAP_LAYERS_RECEIVED";

export interface GetMapLayersParams {
    fields: string;
    ordering: string;
    is_enabled: boolean;
}

export interface MapLayersReceivedInterface {
    meta?: {
        count: number;
        next: null | string;
        previous: null | string;
    };
    results: {
        color: string;
        document: string;
        filter_image: null | string;
        image: null | string;
        name: string;
    }[];
}

export interface MapLayersState {
    mapLayers: MapLayersReceivedInterface;
}
export interface GetMapLayers {
    type: typeof GET_MAP_LAYERS;
    payload: { params: GetMapLayersParams };
}

export interface MapLayersReceived {
    type: typeof MAP_LAYERS_RECEIVED;
    payload: { data: MapLayersReceivedInterface };
}

export type MapLayerTypes = GetMapLayers | MapLayersReceived;
